import Vue from 'vue';
import Overlay from '@/components/Overlay.vue';

Vue.directive('loading', {
  bind(el, b, vnode) {
    const ComponentClass = Vue.extend(Overlay);
    const instance = new ComponentClass();
    vnode.context[`_overlayInstance${instance._uid}`] = instance; //eslint-disable-line
    instance.$mount();
    el.style.position = 'relative'; //eslint-disable-line
    el.appendChild(instance.$el);
    el.setAttribute('data-overlay', instance._uid); //eslint-disable-line
  },
  update(el, b, vnode) {
    const v = vnode.context.reloading;
    const id = el.getAttribute('data-overlay');
    vnode.context[`_overlayInstance${id}`].show = v; //eslint-disable-line
  },
});
